import { InventoryOutlined } from '@mui/icons-material'

import { TenantPermission } from '@tabeeb/enums'
import Routes from '@tabeeb/routes'
import { useSelector } from '@tabeeb/store'
import { NavbarItem } from '@collaborate-health/uikit'
import { hasTenantPermission } from '@tabeeb/modules/permissions/selectors'
import { sessionTitleFormatter } from '@tabeeb/modules/shared/utils/text'
import { getFormsTitle, getIsPowerBIReportsFeatureEnabled } from '@tabeeb/modules/appConfigState/selectors'
import { getHasPowerBIAccess } from '@tabeeb/modules/reports/selectors'

const ReportsTab: React.FC = () => {
  const showGeneratedReports = useSelector((state) => hasTenantPermission(state, TenantPermission.CreateReports))
  const showAllSessions = useSelector((state) => hasTenantPermission(state, TenantPermission.AllSessionsAccess))
  const showAllForms = useSelector((state) => hasTenantPermission(state, TenantPermission.AllFormsView))
  const showPowerBIProviders = useSelector(() => getHasPowerBIAccess())
  const showPowerBIReports = useSelector(getIsPowerBIReportsFeatureEnabled)

  const formsTitle = useSelector(getFormsTitle)

  const subitems = []

  if (showAllSessions) {
    subitems.push({
      subitem: true,
      href: Routes.tenantSessions,
      name: sessionTitleFormatter.format('All sessions'),
      key: 'sessions',
    })
  }

  if (showAllForms) {
    subitems.push({
      href: Routes.allForms,
      name: `All ${formsTitle.toLowerCase()}`,
      key: 'forms',
    })
  }

  if (showPowerBIReports) {
    subitems.push({
      href: Routes.powerBIReports,
      name: 'Analytics reports',
      key: 'analytics',
    })

    if (showPowerBIProviders) {
      subitems.push({
        href: Routes.powerBIReportProviders,
        name: 'Report providers',
        key: 'providers',
      })
    }
  }

  if (showGeneratedReports) {
    subitems.push({
      href: Routes.generatedReports,
      name: 'Generated reports',
      key: 'generated',
    })
  }

  if (subitems.length === 0) {
    return null
  }

  return (
    <NavbarItem name='Reports' href={subitems[0].href} icon={<InventoryOutlined />}>
      {subitems.map((item) => (
        <NavbarItem key={item.key} subitem href={item.href} name={item.name} />
      ))}
    </NavbarItem>
  )
}

export default ReportsTab

